import { Layers } from '@helpers/layers';
import styled from 'styled-components';
const Container = styled.div `
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  z-index: ${Layers.ModalBackdrop};
`;
const ModalBackdropStyles = {
    Container,
};
export default ModalBackdropStyles;
